export default "__VITE_ASSET__D36WrxAj__"